import { useEffect } from "react";

import { Carousel } from "../Carousel/Carousel";
import LazyVideo from "../components/LazyVideo";
import VideoPreloader from "../components/VideoPreloader";
import { prefetchPortfolioVideos } from "../utils/prefetchVideos";
import FilmStrip from "./FilmStrip";

export default function Example() {
  useEffect(() => {
    // Delay non-essential prefetch until the browser is idle to avoid blocking main load.
    const cb = () => prefetchPortfolioVideos({ useFetch: false });
    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const id = window.requestIdleCallback(cb, { timeout: 3000 });
      return () => window.cancelIdleCallback?.(id);
    }
    const t = setTimeout(cb, 3500);
    return () => clearTimeout(t);
  }, []);

  // List of portfolio videos we want to warm while on the main page.
  const preloadList = [
    "/Imgs/WalksOfLight/Walks of light.MP4",
    "/Imgs/ParksNYC/GCM Productions_ParkNYC_no cc, but embeded.mov",
    "/Imgs/WhatIf/WhatIfTrailerSMALLER.mp4",
  ];
  return (
    <div className="bg-offWhite ">
      <main>
        <div>
          <div className="bg-black">
            <div className="relative">
              <div className="mx-auto max-w-7xl">
                <div className="bg-gray-50 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                  <LazyVideo
                    autoPlay
                    loop
                    muted
                    playsInline
                    // hero is above-the-fold: mark priority so it loads immediately
                    priority
                    poster="/Imgs/optimized/CinematicLogo-poster.jpg"
                    preload="metadata"
                    className="object-cover aspect-[3/2] lg:aspect-auto lg:size-full"
                  >
                    <source
                      src="/Imgs/optimized/CinematicLogo-720.webm"
                      type="video/webm"
                    />
                    <source
                      src="/Imgs/optimized/CinematicLogo-720.mp4"
                      type="video/mp4"
                    />
                  </LazyVideo>
                </div>
                <div className="relative z-10  sm:pt-14 lg:w-full lg:max-w-2xl">
                  <svg
                    viewBox="0 0 100 100"
                    preserveAspectRatio="none"
                    aria-hidden="true"
                    className="absolute inset-y-0 right-8 hidden h-full w-80 translate-x-1/2 transform fill-black lg:block"
                  >
                    <polygon points="0,0 90,0 50,100 0,100" />
                  </svg>

                  <div className="relative px-6 py-12 sm:py-32 lg:px-8 lg:py-40 lg:pr-0">
                    <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl">
                      <div className="hidden sm:mb-10 sm:flex"></div>
                      <h1 className="text-balance text-3xl font-semibold tracking-tight text-white sm:text-6xl ">
                        <span className="block text-white text-center sm:text-left">
                          We make your vision
                        </span>
                        <span className="block text-blue-200 text-center sm:text-left">
                          a reality.
                        </span>
                      </h1>
                      <p className="mt-8 text-pretty text-lg font-medium text-white text-center sm:text-xl/8 lg:text-left">
                        From initial concept to the final product, we handle
                        every stage of production for seamless and exceptional
                        results.
                      </p>
                      <div className="mt-10 flex items-center gap-x-6 justify-center lg:justify-start">
                        <a
                          href="#contact-us"
                          className="rounded-md bg-blue-900 hover:bg-blue-500  px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                          Contact Us
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="bg-gray-50 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className=" object-cover aspect-[3/2] lg:aspect-auto lg:size-full"
                >
                  <source src="/CinematicGCMlogo.mp4" type="video/mp4" />
                </video>
              </div> */}
            </div>
          </div>
          {/* Logo cloud */}
          <div
            className="  h-[400px]              
    sm:h-[300px]
    [--p:70px]
    bg-blue-900
    [clip-path:polygon(0_0,100%_0,100%_calc(100%_-_var(--p)),0_100%)]
   "
          >
            <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8">
              <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                <h2 className="mx-auto max-w-md text-pretty text-center text-3xl font-bold tracking-tight text-white lg:max-w-xl lg:text-left sm:text-5xl">
                  Publications <span className="hidden sm:inline">👉🏼</span>
                  <span className="inline sm:hidden">👇🏼</span>
                </h2>
                <div className="mt-8 flow-root self-center lg:mt-0">
                  <div className="-ml-8 -mt-4 flex flex-wrap justify-between lg:-ml-4">
                    <div className="ml-8 flex flex-col items-center sm:flex-row sm:items-center shrink-0 grow justify-center lg:ml-4 lg:grow-0 gap-4 sm:gap-8">
                      <a href="https://shoutoutla.com/meet-maria-alejandra-and-chris-anthony-hernandez-actor-and-filmmaker-couple/">
                        <img
                          alt="ShoutoutLA"
                          src="../Imgs/ShoutoutWhite.png"
                          className="h-12 button-wiggle"
                        />
                      </a>
                      <a href="https://voyagela.com/interview/meet-maria-alejandra-hernandez-of-new-york">
                        <img
                          alt="Level"
                          src="../Imgs/VoyageLaLogo.png"
                          className="h-12 button-wiggle"
                        />
                      </a>
                    </div>
                    <div className="ml-8 mt-4 flex shrink-0 grow justify-center lg:ml-4 lg:grow-0">
                      <a href="https://canvasrebel.com/meet-maria-alejandra-hernandez/">
                        <img
                          alt="CanvasRebel"
                          src="../Imgs/CanvasRebelLogo.png"
                          className="h-8 sm:h10 button-wiggle"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <FilmStrip
            className="relative -mt-[70px]   /* pull up by --p       */
                   h-[400px] sm:h-[300px]
                   [--p:70px] [--s:12px]  /* feel free to adjust */
                   bg-neutral-900 text-white flex items-center
                   justify-center"
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-center">
              Project Highlights
            </h2>
          </FilmStrip>

          <section>
            <div className="flex justify-center p-4">
              <div className="w-full max-w-4xl aspect-video bg-black rounded-2xl shadow-md overflow-hidden">
                <LazyVideo
                  autoPlay
                  muted
                  loop
                  controls
                  playsInline
                  // director reel is important; prefetch to avoid poster showing
                  priority
                  className="w-full h-full object-cover"
                >
                  <source src="../Imgs/DirectorReel.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </LazyVideo>
              </div>
            </div>
            <Carousel></Carousel>
          </section>

          {/* Hidden video preloader: warms a small set of portfolio videos while user is on the main page. */}
          <VideoPreloader urls={preloadList} staggerMs={1000} />
          {/* <div className=" h-10 ">
            <Carousel></Carousel>
          </div>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl h-20 ">
              <Carousel></Carousel>
            </div>
          </div> */}

          {/* <div
            className="bg-offWhite
          "
          >
            <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
              <div className="mt-6 grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-3">
                <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                  <img alt="Tuple" src="../Imgs/WHAT IF.jpg" className="" />
                </div>
                <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                  <img alt="Mirage" src="../Imgs/WHAT IF.png" className="" />
                </div>
                <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                  <img
                    alt="StaticKit"
                    src="../Imgs/Tu Amigo Especialito.JPG"
                    className=""
                  />
                </div>
              </div>
            </div>
          </div> */}
        </div>

        <section className="bg-offWhite py-24 sm:py-32">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto grid max-w-2xl grid-cols-1 lg:mx-0 lg:max-w-none lg:grid-cols-2">
              <div className="flex flex-col pb-10 sm:pb-16 lg:pb-0 lg:pr-8 xl:pr-20">
                <div className="flex gap-2">
                  {" "}
                  <img
                    alt=""
                    src="./Imgs/ParkNYCLogo.png"
                    className="h-12 self-start"
                  />
                  <img
                    alt=""
                    src="./Imgs/WalksOfLight/walks of light logo.svg"
                    className="h-12 self-start"
                  />
                </div>

                <figure className="mt-10 flex flex-auto flex-col justify-between">
                  <blockquote className="text-lg/8 text-gray-900">
                    <p>
                      “I’m very satisfied with the service G.C.M. Productions
                      provides. I’ve worked with them for years on different
                      projects, and they always deliver on time with top-quality
                      results. Their professionalism and attention to detail
                      stand out, and they make sure everything is explained
                      clearly in meetings. Maria, in particular, really
                      understands the vision and makes it happen. Thanks to her,
                      projects like ParkNYC for the city and Walks of Light for
                      my nonprofit foundation came through successfully. I 100%
                      recommend G.C.M. Productions.”
                    </p>
                  </blockquote>
                  <figcaption className="mt-10 flex items-center gap-x-6">
                    <img
                      alt=""
                      src="../Imgs/WalksOfLight/Sojey Fernandez.jpeg"
                      className="size-14 rounded-full bg-gray-50"
                    />
                    <div className="text-base">
                      <div className="font-semibold text-gray-900">
                        Sojey Fernandez
                      </div>
                      <div className="mt-1 text-gray-500">
                        CEO of D&S Agency Corp. and President of Walks of Light
                        Foundation
                      </div>
                    </div>
                  </figcaption>
                </figure>
              </div>
              <div className="flex flex-col border-t border-gray-900/10 pt-10 sm:pt-16 lg:border-l lg:border-t-0 lg:pl-8 lg:pt-0 xl:pl-20">
                <img
                  alt=""
                  src="./Imgs/EmerestAndRoyalCare/Emerest_logo.png"
                  className="h-12 self-start"
                />
                <figure className="mt-10 flex flex-auto flex-col justify-between">
                  <blockquote className="text-lg/8 text-gray-900">
                    <p>
                      “Working with GCM Productions was a great experience! They
                      were able to bring our vision to life seamlessly and
                      hassle free. They are extremely reliable, professional and
                      their work is amazing. Maria listened to what our ideas
                      were for print branding and website images and was able to
                      bring our ideas to life with high quality original images
                      that we now use nationwide for our company. I highly
                      recommend GCM Productions.”
                    </p>
                  </blockquote>
                  <figcaption className="mt-10 flex items-center gap-x-6">
                    <img
                      alt=""
                      src="../Imgs/EmerestAndRoyalCare/DianaDeleanu.jpeg"
                      className="size-14 rounded-full bg-gray-50"
                    />
                    <div className="text-base">
                      <div className="font-semibold text-gray-900">
                        Diana Deleanu
                      </div>
                      <div className="mt-1 text-gray-500">
                        Chief Marketing and Strategy Officer at Emerest & Royal
                        Care
                      </div>
                    </div>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div className="mx-auto grid max-w-2xl grid-cols-1 lg:mx-2 lg:max-w-none lg:grid-cols-1 my-4 ">
              <div className="mx-auto grid max-w-2xl grid-cols-1 lg:mx-2 lg:max-w-none lg:grid-cols-1 my-4 border-t border-gray-900/10 pt-10 sm:pt-16">
                <div className="flex flex-col pb-10 sm:pb-16 lg:pb-0 lg:pr-8 xl:pr-20">
                  <div className="flex gap-2">
                    {" "}
                    <img
                      alt=""
                      src="../Imgs/JbVitalityLogo.png"
                      className="h-12 self-start"
                    />
                  </div>

                  <figure className="mt-10 flex flex-auto flex-col justify-between">
                    <blockquote className="text-lg/8 text-gray-900">
                      <p>
                        “I had the absolute pleasure of working with Maria and
                        Chris from GCM Productions for new videos for my
                        business and I can't recommend them highly enough! As a
                        business owner, it's imperative that who you hire
                        understands your brand, mission and what you are trying
                        to convey to your consumers. Within minutes of meeting
                        and speaking with Maria and Chris, I knew they
                        understood what exactly I wanted and how to do it
                        ensuring that the work aligns and further elevates my
                        brand. They brought in top-of-the-line video equipment,
                        which made a noticeable difference in the quality of the
                        final product. Chris approached every shot with
                        confidence, and with each detail thoughtfully
                        considered, it was clear Chris takes great pride in his
                        craft. Maria was an amazing director throughout the
                        shoot. Her eye for detail and ability to clearly guide
                        me through each shot made the entire process smooth and
                        enjoyable. She gave thoughtful, encouraging direction
                        that helped me feel confident and look my best (no fly
                        away hairs or tags sticking out here!) Working with GCM
                        Productions was not only a professional experience but a
                        truly enjoyable one. I will continue to use GCM
                        Productions for all of my marketing needs for my
                        business. If you're looking for a team that’s both
                        talented and a joy to work with, look no further than
                        Maria and Chris of GCM Productions!”
                      </p>
                    </blockquote>
                    <figcaption className="mt-10 flex items-center gap-x-6">
                      <img
                        alt=""
                        src="../Imgs/JbVitality.jpg"
                        className="size-14 rounded-full bg-gray-50"
                      />
                      <div className="text-base">
                        <div className="font-semibold text-gray-900">
                          Jess Brown
                        </div>
                        <div className="mt-1 text-gray-500">
                          Founder & Owner of JB Vitality
                        </div>
                      </div>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <div className="bg-offWhite py-12 sm:py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl space-y-16 divide-y divide-gray-100 lg:mx-0 lg:max-w-none">
            <div className="grid gap-10 justify-center">
              {/* Contact Us Section */}
              <div id="contact-us">
                <h2 className="text-pretty text-3xl sm:text-4xl font-semibold tracking-tight text-gray-900 py-2 text-center sm:text-center">
                  Get in touch
                </h2>
                <p className="mt-4 text-base leading-7 text-gray-600 py-4 text-center sm:text-left">
                  Let's make your dream concept a reality!
                </p>
                <a
                  href="mailto:GCMProductionsny@gmail.com"
                  className="font-semibold text-blue-600 py-4 block text-center sm:text-center"
                >
                  GCMProductionsny@gmail.com
                </a>

                <a
                  className="flex text-gray-600 hover:text-gray-800 justify-center"
                  href="https://www.instagram.com/g.c.m.productions?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                >
                  <svg
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    className="size-6"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  G.C.M.Productions
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
